import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    appBarSpacer: {
        minHeight: '82px',
        background: 'white',
    },
    header: {
        background: '#E8E8E8',
        display: 'flex',
        alignItems: 'center',
        height: '49px',
        padding: '0px 0px 0 15px',
        "& h1": {
            padding: '0px 15px',
            fontSize: '22px',
            fontWeight: 600,
            lineHeight: '28.8px',
            color: '#2D4D95',
        }
    },
    container: {
        padding: '6px 15px',
    },

    tabsSection: {
        background: '#FFFFFF',
        width: '100%',
        margin: '12px 0',
        display: 'flex',
        alignItems: "center",
        borderRadius: '8px 8px 0px 0px',
        paddingTop: '10px',
    },
    Htabs: {
        "& button": {
            textTransform: "capitalize",
            color: "#3C4549",
            fontFamily: "Lato",
            // width: "80px",
            // maxWidth: "50px",
            fontSize: "16px",
            opacity: "1",
            height: "36px"
        },
        "& button.Mui-selected": {
            fontWeight: 700,
            color: "#3C4549",
            borderRadius: " 0px 10px 0px 0px",
        },
        "& button.Mui-selected:first-child": {
            borderRadius: "10px 0px 0px 0px",
        },
        "& .MuiTabs-indicator": {
            height: '2px',
            backgroundColor: "#3C4549",
            color: "#3C4549",
        },
        "& .MuiTab-root": {
            minWidth: "80px",
            minHeight: "32px",
            maxWidth: "320px",
        }
    },
    tabarea: {
        padding: '0px 10px',
        borderRadius: '10px'
    },
    tabPan: {
        width: "100%",
        background:'white',
        // padding: '15px',
        marginTop:'10px',
        borderRadius:'15px',
        "& .MuiBox-root": {
            padding: '0px 24px',
        }
    },

}));